const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://backendstore-qgk3.onrender.com';

// The backend runs on Render's free tier, which spins the server down after
// inactivity: a cold start can take ~30-50s to respond. A short/default
// timeout would fail a real sale mid cold-start, so checkout-critical
// requests get a generous timeout instead of hanging (or failing) silently.
const CHECKOUT_TIMEOUT_MS = 60000;

const fetchWithTimeout = async (url, options, timeoutMs = CHECKOUT_TIMEOUT_MS) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

  try {
    return await fetch(url, { ...options, signal: controller.signal });
  } catch (error) {
    if (error.name === 'AbortError') {
      throw new Error(
        'El servidor está tardando demasiado en responder. Por favor, intentá de nuevo en unos segundos.',
      );
    }
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }
};

export const createCheckoutPreference = async (payload) => {
  const response = await fetchWithTimeout(`${API_BASE_URL}/crear-preferencia`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || 'No se pudo generar el enlace de pago.');
  }

  return response.json();
};

export const sendOrderEmail = async (payload) => {
  const response = await fetchWithTimeout(`${API_BASE_URL}/send-order-email`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || 'No se pudo enviar el email.');
  }

  return response.json();
};

// Fire-and-forget request meant to be called as soon as the user reaches
// checkout, so a sleeping Render dyno has a head start waking up before the
// real /crear-preferencia submit. `no-cors` because we don't need (or have
// CORS access to) the response -- only triggering the wake-up matters --
// and any failure is swallowed since this must never affect the real flow.
export const warmUpServer = () => {
  try {
    fetch(API_BASE_URL, { method: 'GET', mode: 'no-cors' }).catch(() => {});
  } catch {
    // Ignore: warm-up is best-effort only.
  }
};

export { API_BASE_URL };
